"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dom = require("@active/react-utils/dom");
var _size = _interopRequireDefault(require("lodash/fp/size"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _juxt = _interopRequireDefault(require("lodash/fp/juxt"));
var _eventHandler = require("@active/react-utils/eventHandler");
var _scopedFocus = _interopRequireDefault(require("@active/react-utils/dom/scopedFocus"));
var _Popper = _interopRequireDefault(require("../Popper"));
var _ActiveUIContext = require("../ActiveUIContext");
var _constants = require("../constants");
var _excluded = ["title", "children", "rootElProps", "className", "placement", "content", "theme", "followCursor", "trigger", "timeOut", "distance", "onClose", "onOpen", "rootElement"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var closePopoverActuator;
var timer;
var clearDeferTimer = function clearDeferTimer() {
  timer && clearTimeout(timer);
};
var closePopover = function closePopover() {
  var _closePopoverActuator;
  clearDeferTimer === null || clearDeferTimer === void 0 || clearDeferTimer();
  (_closePopoverActuator = closePopoverActuator) === null || _closePopoverActuator === void 0 || _closePopoverActuator();
  closePopoverActuator = null;
};
var isFocusable = function isFocusable(selector) {
  return (0, _compose["default"])(selector, (0, _dom.tabbable)({
    displayCheck: 'none'
  }));
};
var handleGlobalCloseEvent = function handleGlobalCloseEvent(onClose, callback) {
  var listener = function listener(e) {
    if (e.key === _constants.KEY_VALUES.ESCAPE) {
      e.stopPropagation();
      onClose === null || onClose === void 0 || onClose();
      callback === null || callback === void 0 || callback();
    }
  };
  document.addEventListener('keydown', listener, true);
  return function () {
    document.removeEventListener('keydown', listener, true);
  };
};
var Popover = function Popover(_ref, ref) {
  var _children$props;
  var title = _ref.title,
    children = _ref.children,
    _ref$rootElProps = _ref.rootElProps,
    _ref$rootElProps2 = _ref$rootElProps === void 0 ? {} : _ref$rootElProps,
    rootClass = _ref$rootElProps2.className,
    rootStyle = _ref$rootElProps2.style,
    className = _ref.className,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    content = _ref.content,
    theme = _ref.theme,
    _ref$followCursor = _ref.followCursor,
    followCursor = _ref$followCursor === void 0 ? false : _ref$followCursor,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
    _ref$timeOut = _ref.timeOut,
    timeOut = _ref$timeOut === void 0 ? 200 : _ref$timeOut,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? 8 : _ref$distance,
    onClose = _ref.onClose,
    onOpen = _ref.onOpen,
    rootElement = _ref.rootElement,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    refElement = _useState2[0],
    setRefElement = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var popoverRef = (0, _react.useRef)(null);
  var popoverContentId = "popover-".concat((0, _react.useId)());
  var rootRef = (0, _react.useCallback)(function () {
    return ref || popoverRef;
  }, [ref, popoverRef]);
  var openPopover = (0, _react.useCallback)(function () {
    if (!open) {
      closePopover();
      setOpen(true);
      onOpen === null || onOpen === void 0 || onOpen();
      closePopoverActuator = function closePopoverActuator() {
        setOpen(false);
        onClose === null || onClose === void 0 || onClose();
      };
    }
  }, [open, onOpen, onClose]);
  var deferClosePopover = (0, _react.useCallback)(function () {
    clearDeferTimer();
    timer = setTimeout(function () {
      closePopover();
    }, timeOut);
  }, [timeOut]);
  var handleAnchorMouseEnter = (0, _react.useCallback)(function () {
    open ? clearDeferTimer() : openPopover();
  }, [openPopover, open]);
  var handleClick = (0, _react.useCallback)(function () {
    if (!open) {
      openPopover();
    } else {
      closePopover();
    }
  }, [open, openPopover]);
  var focusAnchor = (0, _react.useCallback)(function () {
    refElement === null || refElement === void 0 || refElement.focus();
  }, [refElement]);
  (0, _react.useEffect)(function () {
    return open ? handleGlobalCloseEvent(deferClosePopover, focusAnchor) : undefined;
  }, [open, deferClosePopover, focusAnchor]);
  (0, _react.useEffect)(function () {
    if (trigger === 'click' && open) {
      return (0, _eventHandler.listenClickEscape)(function () {
        closePopover();
      }, [{
        current: refElement
      }, rootRef()]);
    }
    return undefined;
  }, [trigger, open, refElement, rootRef]);
  (0, _react.useEffect)(function () {
    return function unmountClearUp() {
      closePopover();
    };
  }, []);
  var handleKeydown = (0, _react.useCallback)(function (e) {
    var _rootRef;
    var contentRef = (_rootRef = rootRef()) === null || _rootRef === void 0 ? void 0 : _rootRef.current;
    if (e.key === _constants.KEY_VALUES.TAB) {
      if (contentRef && isFocusable(_size["default"])(contentRef)) {
        e.preventDefault();
        e.stopPropagation();
        (0, _scopedFocus["default"])(contentRef, {
          direction: 'next',
          circular: true
        });
      } else {
        closePopover();
      }
    }
  }, [rootRef]);

  // eslint-disable-next-line
  var mergeEvent = function mergeEvent(key) {
    return function (fn) {
      return children.props[key] ? (0, _juxt["default"])([fn, children.props[key]]) : fn;
    };
  };
  var bindEvents = function bindEvents() {
    var events = {};
    switch (trigger) {
      case 'hover':
        events = {
          onMouseEnter: mergeEvent('onMouseEnter')(handleAnchorMouseEnter),
          onMouseLeave: mergeEvent('onMouseLeave')(deferClosePopover),
          onFocus: mergeEvent('onFocus')(openPopover),
          onKeyDown: mergeEvent('onKeyDown')(handleKeydown)
        };
        break;
      case 'click':
        events = {
          onClick: mergeEvent('onClick')(handleClick),
          onKeyDown: mergeEvent('onKeyDown')(handleKeydown)
        };
        break;
      default:
        break;
    }
    return events;
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].cloneElement(children, _objectSpread({
    ref: setRefElement,
    style: _objectSpread({
      position: 'relative'
    }, (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.style),
    'aria-describedby': open ? popoverContentId : null
  }, bindEvents())), open ? (/*#__PURE__*/_reactDom["default"].createPortal(/*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Popper["default"], {
    style: rootStyle,
    className: rootClass,
    refElement: refElement,
    placement: placement,
    followCursor: followCursor,
    distance: distance
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    id: popoverContentId,
    className: (0, _classnames["default"])('popover popover-open', className, (0, _defineProperty2["default"])({}, "popover-".concat(theme), theme)),
    onMouseEnter: trigger === 'hover' ? clearDeferTimer : undefined,
    onMouseLeave: trigger === 'hover' ? deferClosePopover : undefined,
    onKeyDown: handleKeydown,
    "data-testid": "popover-root",
    ref: rootRef()
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: "popover-header"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "popover-body"
  }, content)))), rootElement)) : null);
};
var ComposedPopover = (0, _ActiveUIContext.withRootElement)((0, _compose["default"])(_react.memo, _react["default"].forwardRef)(Popover));
var _default = exports["default"] = ComposedPopover;